import { contentFactorySurveyDataSchema, ContentFactorySurveyData } from '../../types';

export const ensureIsSurveyData = (o: unknown): o is ContentFactorySurveyData => {
    return contentFactorySurveyDataSchema.safeParse(o).success;
};

export const validateTemplateData = (o: unknown, type: string) => {
    if (type === 'pollSurvey') {
        return ensureIsSurveyData(o);
    }

    return false;
};
